import { useCallback, useEffect, useState } from 'react';
import { ROUTES } from '../../utils/constants';
import { ConfirmationModal } from '../ConfirmationModal';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks';
import { UserRole } from '../../services/api.types';
import dayjs from 'dayjs';
import { apiService } from '../../services/api';

export const PENDING_REPORTS_EXPDT = 'PENDING_REPORTS_EXPDT';

export const PendingReportsModal = () => {
  const user = useAppSelector((state) => state.user);
  const [canOpenModal, setCanOpenModal] = useState<boolean>(false);
  const [pendingReports, setPendingReports] = useState<number>(0);
  const navigate = useNavigate();

  const hasPendingReportsPopupExpired = (): boolean => {
    const popUpExpDate = sessionStorage.getItem(PENDING_REPORTS_EXPDT);
    if (!popUpExpDate) return true;
    return new Date() > new Date(popUpExpDate);
  };

  const handlePendingReportsPopup = useCallback(async (): Promise<void> => {
    if (user?.role !== UserRole.TEACHER) return;
    if (!hasPendingReportsPopupExpired()) return;
    sessionStorage.removeItem(PENDING_REPORTS_EXPDT);

    await apiService.findPendingReports(user.id).then((res) => {
      sessionStorage.setItem(
        PENDING_REPORTS_EXPDT,
        dayjs().add(15, 'minutes').toISOString()
      );
      setPendingReports(res.pendingReports);
      setCanOpenModal(true);
    });
  }, [user]);

  useEffect(() => {
    handlePendingReportsPopup();
    const interval = setInterval(handlePendingReportsPopup, 15 * 1000);
    return () => clearInterval(interval);
  }, [handlePendingReportsPopup]);

  const handleClose = () => {
    setCanOpenModal(false);
  };

  const handleAccept = () => {
    navigate(ROUTES.reports.index);
    handleClose();
  };

  const openModal = canOpenModal && pendingReports > 0 && user !== null;
  if (!openModal) return null;

  return (
    <ConfirmationModal
      open={openModal}
      onDecline={handleClose}
      onAccept={handleAccept}
      acceptText="Ver relatórios"
      declineText="Fechar"
      title="Relatórios pendentes"
      description={`Caro professor, você possui ${pendingReports} ${
        pendingReports > 1 ? 'relatórios pendentes' : 'relatório pendente'
      }.`}
    />
  );
};
